import React, { useCallback, useEffect, useRef } from 'react';
import classNames from 'classnames';
import { getTooltip, getTooltipTheme } from '../../../lib/_util/TooltipUtils';
import { hide, show } from '../tooltip/singleton';
import Row from '../row';
import Col from '../col';
import { Tooltip as TextTooltip } from '../core/enum';
import isOverflow from '../overflow-tip/util';
const MultiLine = (props) => {
    const { prefixCls, label, validationMessage, required, validationHidden, tooltip = getTooltip('output'), labelTooltip, children } = props;
    const tooltipRef = useRef(false);
    const handleLabelMouseEnter = useCallback((e) => {
        const { currentTarget } = e;
        if (labelTooltip === TextTooltip.always || (labelTooltip === TextTooltip.overflow && isOverflow(currentTarget))) {
            show(currentTarget, { title: label, placement: 'right' });
            tooltipRef.current = true;
        }
    }, [label, labelTooltip, tooltipRef]);
    const handleFieldMouseEnter = useCallback((e) => {
        const { currentTarget } = e;
        if (validationMessage) {
            show(currentTarget, {
                title: validationMessage,
                placement: 'bottomLeft',
                theme: getTooltipTheme('validation'),
            });
            tooltipRef.current = true;
        }
        else if (tooltip === TextTooltip.always || (tooltip === TextTooltip.overflow && isOverflow(currentTarget))) {
            show(currentTarget, { title: children, placement: 'right' });
            tooltipRef.current = true;
        }
    }, [tooltip, validationMessage, children, tooltipRef]);
    const handleMouseLeave = useCallback(() => {
        if (tooltipRef.current) {
            hide();
            tooltipRef.current = false;
        }
    }, [tooltipRef]);
    useEffect(() => () => {
        if (tooltipRef.current) {
            hide();
            tooltipRef.current = false;
        }
    }, [tooltipRef]);
    return (React.createElement(Row, { className: `${prefixCls}-multi` },
        label && (React.createElement(Col, { span: 8, className: classNames(`${prefixCls}-multi-label`, { [`${prefixCls}-multi-label-required`]: required }), onMouseEnter: handleLabelMouseEnter, onMouseLeave: handleMouseLeave }, label)),
        React.createElement(Col, { span: label ? 16 : 24, className: classNames(`${prefixCls}-multi-value`, { [`${prefixCls}-multi-value-invalid`]: !validationHidden }), onMouseEnter: handleFieldMouseEnter, onMouseLeave: handleMouseLeave }, children)));
};
MultiLine.displayName = 'MultiLine';
export default MultiLine;
